export interface IAuthProvider {
  type: string;
  userExternalId: string;
  userExternalDisplayId: string;
}
